import React, { useEffect, useState } from 'react';
import { InstagramIcon, Menu, X } from 'lucide-react';
import { ImdbIcon } from './ImdbIcon';
import { Link } from 'react-router-dom';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-sm py-3' : 'bg-transparent py-5'}`} data-id="element-254">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-255">
        <Link to="/" className="text-2xl font-bold tracking-tighter text-white flex items-center" data-id="element-256">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJy59TMDp1yB3h9h9tuSsL/LOGO_BLUEsmall.png" alt="Blue Rain Productions Logo" className="h-12 mr-2" data-id="element-257" />
        </Link>
        <nav className="hidden md:flex items-center space-x-8" data-id="element-258">
          <Link to="/" className="text-white hover:text-blue-400 transition-colors" data-id="element-259">
            Home
          </Link>
          <Link to="/#about" className="text-white hover:text-blue-400 transition-colors" onClick={e => {
          if (window.location.pathname === '/') {
            e.preventDefault();
            document.getElementById('about')?.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-260">
            Over ons
          </Link>
          <Link to="/producties" className="text-white hover:text-blue-400 transition-colors" data-id="element-261">
            Producties
          </Link>
          <Link to="/#contact" className="text-white hover:text-blue-400 transition-colors" onClick={e => {
          if (window.location.pathname === '/') {
            e.preventDefault();
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-262">
            Contact
          </Link>
        </nav>
        <div className="hidden md:flex items-center space-x-4" data-id="element-263">
          <a href="https://www.instagram.com/martijn_mantel/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors" data-id="element-264">
            <InstagramIcon size={20} data-id="element-265" />
          </a>
          <a href="https://www.imdb.com/name/nm10911429/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors" data-id="element-266">
            <ImdbIcon size={20} data-id="element-267" />
          </a>
        </div>
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-268">
          {isMenuOpen ? <X size={24} data-id="element-269" /> : <Menu size={24} data-id="element-270" />}
        </button>
      </div>
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-black/95 backdrop-blur-sm" data-id="element-271">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-272">
            <Link to="/" className="text-white py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-273">
              Home
            </Link>
            <Link to="/#about" className="text-white py-2 hover:text-blue-400 transition-colors" onClick={e => {
          setIsMenuOpen(false);
          if (window.location.pathname === '/') {
            e.preventDefault();
            document.getElementById('about')?.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-274">
              Over ons
            </Link>
            <Link to="/producties" className="text-white py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-275">
              Producties
            </Link>
            <Link to="/#contact" className="text-white py-2 hover:text-blue-400 transition-colors" onClick={e => {
          setIsMenuOpen(false);
          if (window.location.pathname === '/') {
            e.preventDefault();
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-276">
              Contact
            </Link>
            <div className="flex items-center space-x-4 py-2" data-id="element-277">
              <a href="https://www.instagram.com/martijn_mantel/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors" data-id="element-278">
                <InstagramIcon size={20} data-id="element-279" />
              </a>
              <a href="https://www.imdb.com/name/nm10911429/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors" data-id="element-280">
                <ImdbIcon size={20} data-id="element-281" />
              </a>
            </div>
          </div>
        </div>}
    </header>;
};